import * as BABYLON from '@babylonjs/core'


export const MESH_ROOT_URL: string = 'files/meshes/'

export const ROULETTE_FILE_NAME: string = 'roulette-model.babylon'
export const TABLE_FILE_NAME: string = 'table.babylon'
export const ENV_TEXTURE_FILE_NAME: string = 'studio.env'

export const ENV_TEXTURE_TASK_NAME: string = 'ENV'

export const CENTRAL_MESH_NAME: string = 'centralWithFloor'
export const EXTERNAL_SPOTS_TORUS_MESH_NAME: string = 'externalSpotsOutline'
export const INTERNAL_SPOTS_TORUS_MESH_NAME: string = 'internalSpotsOutline'
export const SPOTS_MESH_NAME: string = 'spots'
export const CHECK_STICK_MESH_NAME: string = 'checkStick'

export const FRAME_RATE: number = 30

export const START_SPEED_FOR_DISPERSE: number = 0.01
export const ACCELERATION_FOR_SPEED_FOR_DISPERSE: number = 0.0002
export const SPREAD_FOR_ACCELERATION: number = 0.00005
export const ACCELERATION_FOR_SPEED_FOR_BRAKING: number = 0.0002
export const UPPER_DISPERSE_SPEED_LIMIT: number = 0.07
export const LOWER_BRAKING_SPEED_LIMIT: number = 0.001
export const INTERVAL_OF_MOVING: number = 14

const DEFAULT_CAMERA_X: number = 0
const DEFAULT_CAMERA_Y: number = 14
const DEFAULT_CAMERA_Z: number = -39

const RANDOM_CAMERA_X: number = 0
const RANDOM_CAMERA_Y: number = 11
const RANDOM_CAMERA_Z: number = -15

const ZOOM_CAMERA_X: number = 0
const ZOOM_CAMERA_Y: number = 21
const ZOOM_CAMERA_Z: number = 0

export const CAMERA_POSITION_NEAR = new BABYLON.Vector3(RANDOM_CAMERA_X, RANDOM_CAMERA_Y, RANDOM_CAMERA_Z);
export const CAMERA_POSITION_DEFAULT = new BABYLON.Vector3(DEFAULT_CAMERA_X, DEFAULT_CAMERA_Y, DEFAULT_CAMERA_Z);
export const CAMERA_POSITION_ZOOM = new BABYLON.Vector3(ZOOM_CAMERA_X, ZOOM_CAMERA_Y, ZOOM_CAMERA_Z);